import PropTypes from "prop-types";
import React from "react";
import { useSelector } from "react-redux";

const Index = (props) => {

  const isSubmitting = useSelector((state) => state?.button);
  const { title, className } = props;

  return (
    <button className={className} disabled={isSubmitting}>
      {isSubmitting ? (
        <output aria-live="polite">
          <span
            className="spinner-border spinner-border-sm"
            aria-hidden="true"
          />{" "}
          Loading...
        </output>
      ) : (
        title
      )}
    </button>
  );
};

Index.propTypes = {
  title: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default Index;
